import { Range, Point } from "slate";
const LocationUtils = {
  getStartPath(location) {
    if (Range.isRange(location))
      return Range.start(location).path;
    if (Point.isPoint(location))
      return location.path;
    return location;
  }
};
export {
  LocationUtils
};
//# sourceMappingURL=location.js.map